import React from 'react';
export function Header() {
  return <header className="bg-[#070B16]/95 backdrop-blur-sm py-3 px-5 md:px-8 sticky top-0 z-50 border-b border-[#15203B] shadow-lg" data-id="element-202">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-center gap-3 md:gap-0" data-id="element-203">
        <div className="text-gray-300 text-sm md:text-base font-medium text-center md:text-left max-w-lg" data-id="element-204">
          Especial para personas que sienten zumbido, pitido o presión auditiva
          al dormir
        </div>
        <a href="#comprar" className="bg-[#F6C65B] hover:bg-[#FFD680] text-[#070B16] font-bold px-5 py-2 rounded transition-all duration-300 shadow-[0_0_15px_rgba(246,198,91,0.3)] text-sm transform hover:scale-105 active:scale-95 flex items-center justify-center w-full md:w-auto" data-id="element-205">
          Ver Protocolo
        </a>
      </div>
    </header>;
}